export const TALK_VERSION = {
  '10.0.5': '10.0.5',
  '10.1.0': '10.1.0',
  '10.2.0': '10.2.0',
  '10.9.0': '10.9.0',
  '11.2.0': '11.2.0',
  '11.3.0': '11.3.0',
  '25.3.0': '25.3.0'
} as const;
